/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
    useGetClientFilterQuery,
    useGetCountryFilterQuery,
    useGetParentClientFilterQuery,
    useGetProgramFilterQuery,
    useGetProjectFilterQuery,
    useGetSiteFilterQuery,
} from '../../scoreCardFilter/scoreCardFilterSlice';
import { LoadingSpinner } from '../../loadingSpinner/loadingspinner';
import './scorecardFilter.scss';
import { selectCurrentIsAdmin, selectCurrentisComp, selectCurrentIsEds, selectCurrentIsHC, selectCurrentUserParentClient } from '../../../pages/login/authSlice';
import { removeSelectedLocalStorageKeys } from '../../../utils/clearLocalStorageKeys';

type scorecardFilterProps = {
    scorecardData: (value: any) => void;
    ipInputMonth: number;
    ipInputYear: number;
    ipSetInputScorecard: React.Dispatch<React.SetStateAction<string | number>>;
    resetDate: () => void;
    disablefilterMenu1?: boolean;
    filterDisabled?: boolean;
    setParentClientId?: React.Dispatch<any>;
    inputScorecardVersion: string | number;
    setDimensionsData: React.Dispatch<any>;
    setInputScorecardVersion: React.Dispatch<any>;
};

export const ScorecardFilter = ({
    scorecardData,
    ipInputMonth,
    ipInputYear,
    ipSetInputScorecard,
    resetDate,
    disablefilterMenu1,
    filterDisabled,
    setParentClientId,
    inputScorecardVersion,
    setDimensionsData,
    setInputScorecardVersion,
}: scorecardFilterProps) => {
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isEds = useSelector(selectCurrentIsEds);
    const isComp = useSelector(selectCurrentisComp);
    const isHC = useSelector(selectCurrentIsHC);

    const currentUserParentClient = useSelector(selectCurrentUserParentClient);
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());

    const [loading, setLoading] = useState<boolean>(false);

    const [parentClientFilter, setParentClientFilter] = useState<any>([]);
    const [selectedParentClient, setSelectedParentClient] = useState<number | null>(null);
    const [clientFilter, setClientFilter] = useState<any>([]);
    const [selectedClient, setSelectedClient] = useState<number | null>(null);
    const [programFilter, setProgramFilter] = useState<any>([]);
    const [selectedProgram, setSelectedProgram] = useState<number | null>(null);
    const [projectFilter, setProjectFilter] = useState<any>([]);
    const [selectedProject, setSelectedProject] = useState<number | null>(null);
    const [countryFilter, setCountryFilter] = useState<any>([]);
    const [selectedCountry, setSelectedCountry] = useState<number | null>(null);
    const [siteFilter, setSiteFilter] = useState<any>([]);
    const [selectedSite, setSelectedSite] = useState<number | null>(null);
    const [refetchKey, setRefetchKey] = useState<boolean>(false);

    const { scid } = useParams();
    useEffect(() => {
        setMonth(ipInputMonth);
        setYear(ipInputYear);
    }, [ipInputMonth, ipInputYear]);

    const { data: parentClientFilterData, isFetching: parentClientFetching } = useGetParentClientFilterQuery({
        year: inputYear,
        month: inputMonth,
        scorecardVersionId: inputScorecardVersion,
        clientId: selectedClient ?? '',
        programId: selectedProgram ?? '',
        projectId: selectedProject ?? '',
        countryId: selectedCountry ?? '',
        geolocationId: selectedSite ?? '',
        refetchKey,
    });

    const { data: clientFilterData, isFetching: clientFetching } = useGetClientFilterQuery({
        year: inputYear,
        month: inputMonth,
        scorecardVersionId: inputScorecardVersion,
        parentClientId: selectedParentClient ?? '',
        programId: selectedProgram ?? '',
        projectId: selectedProject ?? '',
        countryId: selectedCountry ?? '',
        geolocationId: selectedSite ?? '',
        refetchKey,
    });

    const { data: programFilterData, isFetching: programFetching } = useGetProgramFilterQuery({
        year: inputYear,
        month: inputMonth,
        scorecardVersionId: inputScorecardVersion,
        parentClientId: selectedParentClient ?? '',
        clientId: selectedClient ?? '',
        projectId: selectedProject ?? '',
        countryId: selectedCountry ?? '',
        geolocationId: selectedSite ?? '',
        refetchKey,
    });

    const { data: projectFilterData, isFetching: projectFetching } = useGetProjectFilterQuery({
        year: inputYear,
        month: inputMonth,
        scorecardVersionId: inputScorecardVersion,
        parentClientId: selectedParentClient ?? '',
        clientId: selectedClient ?? '',
        programId: selectedProgram ?? '',
        countryId: selectedCountry ?? '',
        geolocationId: selectedSite ?? '',
        refetchKey,
    });

    const { data: countryFilterData, isFetching: countryFetching } = useGetCountryFilterQuery({
        year: inputYear,
        month: inputMonth,
        scorecardVersionId: inputScorecardVersion,
        parentClientId: selectedParentClient ?? '',
        clientId: selectedClient ?? '',
        programId: selectedProgram ?? '',
        geolocationId: selectedSite ?? '',
        refetchKey,
    });

    const { data: siteFilterData, isFetching: siteFetching } = useGetSiteFilterQuery({
        year: inputYear,
        month: inputMonth,
        scorecardVersionId: inputScorecardVersion,
        parentClientId: selectedParentClient ?? '',
        clientId: selectedClient ?? '',
        programId: selectedProgram ?? '',
        countryId: selectedCountry ?? '',
        refetchKey,
    });

    const resetAllFilters = () => {
        setDimensionsData({});
        setRefetchKey((prev) => !prev); // to load the dimensions on every reset

        removeSelectedLocalStorageKeys([
            'ScFilDdlParClient',
            'ScFilDdlClient',
            'ScFilDdlProgram',
            'ScFilDdlProject',
            'ScFilDdlCountry',
            'ScFilDdlSite',
            'ScFilDdlScorecard',
            'ScFilDdlScorecardId',
            'ScFilDdlScorecardName',
            'SCfilDate',
        ]);

        ipSetInputScorecard('');
        setInputScorecardVersion('');

        setParentClientFilter([]);
        setSelectedParentClient(null);

        setClientFilter([]);
        setSelectedClient(null);

        setProgramFilter([]);
        setSelectedProgram(null);

        setProjectFilter([]);
        setSelectedProject(null);

        setCountryFilter([]);
        setSelectedCountry(null);

        setSiteFilter([]);
        setSelectedSite(null);

        scorecardData('');
        resetDate();
    };
    const onParentClientChange = (e: { value: any }) => {
        setSelectedParentClient(e.value);
        if (setParentClientId) setParentClientId(e.value);
        window.localStorage.ScFilDdlParClient = e.value;
        setDimensionsData((prev: any) => ({
            ...prev,
            parentClientId: e.value,
        }));
    };

    const onClientChange = (e: { value: any }) => {
        setSelectedClient(e.value);
        window.localStorage.ScFilDdlClient = e.value;
        setDimensionsData((prev: any) => ({
            ...prev,
            clientId: e.value,
        }));
    };

    const onProgramChange = (e: { value: any }) => {
        setSelectedProgram(e.value);
        window.localStorage.ScFilDdlProgram = e.value;
        setDimensionsData((prev: any) => ({
            ...prev,
            programId: e.value,
        }));
    };

    const onProjectChange = (e: { value: any }) => {
        setSelectedProject(e.value);
        window.localStorage.ScFilDdlProject = e.value;
        setDimensionsData((prev: any) => ({
            ...prev,
            projectId: e.value,
        }));
    };

    const onCountryChange = (e: { value: any }) => {
        setSelectedCountry(e.value);
        window.localStorage.ScFilDdlCountry = e.value;
        setDimensionsData((prev: any) => ({
            ...prev,
            countryId: e.value,
        }));
    };

    const onSiteChange = (e: any) => {
        setSelectedSite(e.value);
        window.localStorage.ScFilDdlSite = e.value;
        setDimensionsData((prev: any) => ({
            ...prev,
            geolocationId: e.value,
        }));
    };

    useEffect(() => {
        if (scid) {
            window.localStorage.ScFilDdlScorecard = scid;
        }
    }, []);

    useEffect(() => {
        if (
            parentClientFetching ||
            clientFetching ||
            programFetching ||
            projectFetching ||
            countryFetching ||
            siteFetching
        ) {
            setLoading(true);
        } else setLoading(false);
    }, [
        parentClientFetching,
        clientFetching,
        programFetching,
        projectFetching,
        countryFetching,
        siteFetching,
    ]);
    useEffect(() => {
        if (parentClientFilterData?.data.length > 0) {
            setParentClientFilter(parentClientFilterData?.data);
            const hasParentClient = parentClientFilterData?.data?.some(
                (item: any) => item.parent_client_id === currentUserParentClient[0]
            );
            if (!isAdmin && !isComp && !isEds && !isHC) {
                if (window.localStorage.getItem('ScFilDdlParClient') !== null) {
                    setSelectedParentClient(parseInt(window.localStorage.ScFilDdlParClient, 10));
                } else if (currentUserParentClient?.length > 0 && hasParentClient) {
                    setSelectedParentClient(currentUserParentClient[0]);
                    if (setParentClientId) setParentClientId(currentUserParentClient[0]);
                    window.localStorage.ScFilDdlParClient = currentUserParentClient[0];

                    setDimensionsData((prev: any) => ({
                        ...prev,
                        parentClientId: currentUserParentClient[0],
                    }));
                }
            }
        }
    }, [parentClientFilterData]);

    useEffect(() => {
        if (clientFilterData?.data.length > 0) {
            setClientFilter(clientFilterData?.data);
            if (window.localStorage.ScFilDdlClient)
                setSelectedClient(parseInt(window.localStorage.ScFilDdlClient, 10));
        }
    }, [clientFilterData]);

    useEffect(() => {
        if (programFilterData?.data.length > 0) {
            setProgramFilter(programFilterData?.data);
            if (window.localStorage.ScFilDdlProgram)
                setSelectedProgram(parseInt(window.localStorage.ScFilDdlProgram, 10));
        }
    }, [programFilterData]);

    useEffect(() => {
        if (projectFilterData?.data.length > 0) {
            setProjectFilter(projectFilterData?.data);
            if (window.localStorage.ScFilDdlProject)
                setSelectedProject(parseInt(window.localStorage.ScFilDdlProject, 10));
        }
    }, [projectFilterData]);

    useEffect(() => {
        if (countryFilterData?.data.length > 0) {
            setCountryFilter(countryFilterData?.data);
            if (window.localStorage.ScFilDdlCountry)
                setSelectedCountry(parseInt(window.localStorage.ScFilDdlCountry, 10));
        }
    }, [countryFilterData]);

    useEffect(() => {
        if (siteFilterData?.data.length > 0) {
            setSiteFilter(siteFilterData?.data);
            if (window.localStorage.ScFilDdlSite)
                setSelectedSite(parseInt(window.localStorage.ScFilDdlSite, 10));
        }
    }, [siteFilterData]);
    return (
        <>
            <div className={`${disablefilterMenu1 ? 'disabled-div' : ''}`}>
                <div className="filter-row">
                    <div className="filter-item">
                        <h6>Parent Client</h6>
                        <Dropdown
                            disabled={filterDisabled}
                            value={selectedParentClient}
                            options={parentClientFilter}
                            onChange={onParentClientChange}
                            optionLabel="parent_client_name"
                            optionValue="parent_client_id"
                            placeholder="Select Parent Client"
                        />
                    </div>
                    <div className="filter-item">
                        <h6>Client</h6>
                        <Dropdown
                            disabled={filterDisabled}
                            value={selectedClient}
                            options={clientFilter}
                            onChange={onClientChange}
                            optionLabel="client_name"
                            optionValue="client_id"
                            placeholder="Select Client"
                        />
                    </div>
                    <div className="filter-item">
                        <h6>Program</h6>
                        <Dropdown
                            disabled={filterDisabled}
                            value={selectedProgram}
                            options={programFilter}
                            onChange={onProgramChange}
                            optionLabel="program_name"
                            optionValue="program_id"
                            placeholder="Select Program"
                        />
                    </div>
                    <div className="filter-item">
                        <h6>Project</h6>
                        <Dropdown
                            disabled={filterDisabled}
                            value={selectedProject}
                            options={projectFilter}
                            onChange={onProjectChange}
                            optionLabel="project_name"
                            optionValue="project_id"
                            placeholder="Select Project"
                        />
                    </div>
                    <div className="filter-item">
                        <h6>Country</h6>
                        <Dropdown
                            disabled={filterDisabled}
                            value={selectedCountry}
                            options={countryFilter}
                            onChange={onCountryChange}
                            optionLabel="country_name"
                            optionValue="country_id"
                            placeholder="Select Country"
                        />
                    </div>
                    <div className="filter-item">
                        <h6>Site</h6>
                        <Dropdown
                            disabled={filterDisabled}
                            value={selectedSite}
                            options={siteFilter}
                            onChange={onSiteChange}
                            optionLabel="site_name"
                            optionValue="site_id"
                            placeholder="Select Site"
                        />
                    </div>
                </div>
            </div>

            <span>{loading ? <LoadingSpinner /> : ''}</span>

            <Button
                label="Reset"
                style={{ top: '-140px' }}
                disabled={filterDisabled}
                className="btn-secondary mb-2 float-end"
                onClick={resetAllFilters}
            />
        </>
    );
};
